import type { SellerSession } from "@/lib/api/types";
import { hasPermission, PERMISSIONS } from "@/modules/auth/useSession";

/**
 * MAY THIS SESSION SEND TO THE KITCHEN — the server's rule, read in one place
 * by the till's primary button and by the cashier's alerts.
 *
 * The kitchen rung (`ITEM_FIRE`) always. And when the store routes waiters'
 * orders through the cashier (D121, `ordersViaCashier`), the cashier's rung
 * (`INVOICE_CLOSE`) as well — the server refuses the fire without it, so a
 * waiter's till offers "Send to cashier" (D120) instead.
 *
 * `ordersViaCashier` undefined (settings still loading, or an older API) reads
 * as off, the store default.
 */
export function canSendToKitchen(
  session: SellerSession | undefined,
  ordersViaCashier: boolean | undefined,
): boolean {
  if (!hasPermission(session, PERMISSIONS.ITEM_FIRE)) return false;
  return !ordersViaCashier || hasPermission(session, PERMISSIONS.INVOICE_CLOSE);
}

/**
 * MAY THIS SESSION ANSWER A DINER'S QR REQUEST — accept or reject.
 *
 * Adding to the bill (`INVOICE_APPEND`) always. Accepting puts the food in the
 * kitchen's queue, so with the D121 switch on it is the cashier's answer too
 * (`INVOICE_CLOSE`), and the server refuses anyone else.
 */
export function canAnswerQrRequests(
  session: SellerSession | undefined,
  ordersViaCashier: boolean | undefined,
): boolean {
  if (!hasPermission(session, PERMISSIONS.INVOICE_APPEND)) return false;
  return !ordersViaCashier || hasPermission(session, PERMISSIONS.INVOICE_CLOSE);
}
